import { initialProject } from "../../system/initial/project";
import { ProjectInterface } from "./interface";
import { PROJECT_ACTIONS, ProjectState } from "./types";

const initialState: ProjectState = {
    projectId: "",
    pageCommand: "",
    pageCommandId: "",
    pageCommandSubSelect: "",
    projectData: initialProject
};

const projectReducer = (
    state: ProjectState | undefined,
    action: ProjectInterface
): ProjectState => {

    if (typeof state === 'undefined') {
        state = initialState;
    }

    switch (action.type) {
        case PROJECT_ACTIONS.setProjectId:
            return {
                ...state,
                projectId: action.payload
            };
        case PROJECT_ACTIONS.setProjectData:
            return {
                ...state,
                projectData: action.payload
            };
        case PROJECT_ACTIONS.setPageCommand:
            const id = action.payload === '' ? '' : state.pageCommandId;
            const subSelect = action.payload === '' ? '' : state.pageCommandSubSelect;
            return {
                ...state,
                pageCommand: action.payload,
                pageCommandId: id,
                pageCommandSubSelect: subSelect,
            };
        case PROJECT_ACTIONS.setPageCommandID:
            return {
                ...state,
                pageCommandId: action.payload
            };
        case PROJECT_ACTIONS.setPageCommandSubSelect:
            return {
                ...state,
                pageCommandSubSelect: action.payload
            };
        case PROJECT_ACTIONS.clearProjectData:
            return initialState;
        default:
            return state;
    }

};

export {projectReducer}
